import { Fragment, useRef } from "react";
import "./style.css";
import Navbar from "CommonComponents/Navbar/Navbar";
import HeroImage from "./HeroImage/HeroImage";
import { useParams } from "react-router-dom";

import FooterA from "Pages/Home/FooterA/FooterA";
import FooterB from "Pages/Home/FooterB/FooterB";
import AllCategoryBoxes from "./AllCategoryBoxes/AllCategoryBoxes";
import ChooseCtegory from "./ChooseSubCtegory/ChooseSubCtegory";

const AllCategories = () => {
  document.title = " داپ اَپ ؛ لیست دسته بندی ها ";
  const { id } = useParams();
  const catBox = useRef();
  return (
    <Fragment>
      <header>
        <Navbar />
      </header>
      <main className="px-2">
        <HeroImage />
        <div className="all-sub-ctegory d-flex justify-content-between  container p-0 my-4">
          <div className="right-category-select w-25 ps-4 ">
            <ChooseCtegory catBox={catBox} />
          </div>
          <div className="left-category-show w-75 pe-5  " ref={catBox}>
            <AllCategoryBoxes paramsId={id} catBox={catBox} />
          </div>
        </div>
      </main>
      <footer>
        <FooterA />
        <FooterB />
      </footer>
    </Fragment>
  );
};

export default AllCategories;
